import { useContext } from "react";
import { GlobalContext } from "../providers/GlobalProvider";

const useUser = () => {
  const { user, setUser } = useContext(GlobalContext);

  return { user, setUser };
};

export default useUser;
